"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * cache decorator
 *
 * property decorator that will cache the result for specific time
 */
var objectMap = new WeakMap();
var nextObjId = 0;
var expireMap = {};
var valueMap = {};
function getObjectKey(obj) {
    var key = objectMap.get(obj);
    if (!key) {
        objectMap.set(obj, ++nextObjId);
        key = nextObjId;
    }
    return "" + key;
}
function getCacheKey(obj, name) {
    return getObjectKey(obj) + "_" + name;
}
function isCacheValid(obj, name) {
    var expires = expireMap[getCacheKey(obj, name)];
    return expires && expires > new Date();
}
function nextExpire(delay) {
    return new Date(new Date().valueOf() + delay);
}
function getCachedValue(obj, key, inner, expiry) {
    var cacheKey = getCacheKey(obj, key);
    if (isCacheValid(obj, key)) {
        return valueMap[getCacheKey(obj, key)];
    }
    var val = inner.apply(obj);
    expireMap[cacheKey] = nextExpire(expiry);
    valueMap[cacheKey] = val;
    return val;
}
function setCacheValue(obj, key, val, inner, expiry) {
    var cacheKey = getCacheKey(obj, key);
    if (inner) {
        inner.call(obj, val);
    }
    else {
        Object.defineProperty(obj, key, Object.assign(Object.getOwnPropertyDescriptor(obj, key), { value: val }));
    }
    expireMap[cacheKey] = nextExpire(expiry);
    valueMap[cacheKey] = val;
}
// tslint:disable:no-invalid-this
// tslint:disable:no-function-expression
function cache(time) {
    return function (target, propertyKey, descriptor) {
        var innerGet = descriptor.get;
        if (typeof innerGet === 'function') {
            var outter = function () {
                return getCachedValue(this, propertyKey, innerGet, time);
            };
            descriptor.get = outter;
        }
        if (descriptor.set) {
            var innerSet_1 = descriptor.set;
            descriptor.set = function (val) {
                setCacheValue(this, propertyKey, val, innerSet_1, time);
            };
        }
        return descriptor;
    };
}
exports.cache = cache;
//# sourceMappingURL=cache.js.map